import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Identification } from '../components/sections/Identification';
import { EmotionalValidation } from '../components/sections/EmotionalValidation';
import { Problem } from '../components/sections/Problem';
import { MiniProductReveal } from '../components/sections/MiniProductReveal';
import { WhatIsIt } from '../components/sections/WhatIsIt';
import { HowItWorks } from '../components/sections/HowItWorks';
import { IntermediateCTA } from '../components/sections/IntermediateCTA';
import { ProductReveal } from '../components/sections/ProductReveal';
import { ForWhom } from '../components/sections/ForWhom';
import { CentralPromise } from '../components/sections/CentralPromise';
import { OfferStack } from '../components/sections/OfferStack';
import { Bonuses } from '../components/sections/Bonuses';
import { Testimonials } from '../components/sections/Testimonials';
import { Guarantee } from '../components/sections/Guarantee';
import { FinalCTA } from '../components/sections/FinalCTA';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-slate-50 font-sans text-slate-900 selection:bg-fuchsia-200 selection:text-fuchsia-900" data-id="element-317">
      <Hero data-id="element-318" />
      <Identification data-id="element-319" />
      <EmotionalValidation data-id="element-320" />
      <Problem data-id="element-321" />
      <MiniProductReveal data-id="element-322" />
      <WhatIsIt data-id="element-323" />
      <HowItWorks data-id="element-324" />
      <IntermediateCTA data-id="element-325" />
      <ProductReveal data-id="element-326" />
      <ForWhom data-id="element-327" />
      <CentralPromise data-id="element-328" />
      <OfferStack data-id="element-329" />
      <Bonuses data-id="element-330" />
      <Testimonials data-id="element-331" />
      <Guarantee data-id="element-332" />
      <FinalCTA data-id="element-333" />

      <PurchaseNotification data-id="element-334" />

      <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm" data-id="element-335">
        <div className="max-w-6xl mx-auto px-4" data-id="element-336">
          <p className="mb-4" data-id="element-337">
            © {new Date().getFullYear()} ENERGÍA REAL. Todos los derechos
            reservados.
          </p>
          <p className="max-w-2xl mx-auto opacity-70" data-id="element-338">
            Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </main>;
}